
// import Mock from 'mockjs'

const Mock = require('mockjs')
import color from './color.json'


// 拦截ajax请求，配置mock的数据
// Mock.mock('/api/articles', 'get', articles)
Mock.mock('/api/color', 'post',
  (params) => {
    const body = params.body
    let newbody = body.split('~')
   let newcolor =  color.slice(newbody[0],newbody[1]*1+1)
    return {
      code: 200,
      message: 'success',
      list: newcolor,


    }
  })


